import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const LINES = [
  "Picking the most useful words for you...",
  "Writing friendly example sentences...",
  "Mixing in some fun challenges...",
  "Double-checking the answers...",
  "Almost there, warming up the voice...",
];

export const GeneratingState = ({ title = "Preparing your lesson", error, onRetry }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % LINES.length), 3500);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="generating-state" className="max-w-md mx-auto text-center py-24 px-4">
      {error ? (
        <>
          <p data-testid="generating-error" className="text-rose-600 font-semibold mb-4">{error}</p>
          <button data-testid="generating-retry-button" onClick={onRetry} className="btn-primary">Try again</button>
        </>
      ) : (
        <>
          <div className="mx-auto h-20 w-20 rounded-3xl bg-[hsl(var(--primary-light))] grid place-items-center mb-6 animate-float">
            <Sparkles className="text-[hsl(var(--primary))]" size={34} />
          </div>
          <h2 className="font-display text-2xl font-bold text-slate-900 mb-2">{title}</h2>
          <p key={i} className="text-slate-600 animate-fade-up">{LINES[i]}</p>
          <div className="mt-8 h-2 rounded-full bg-slate-100 overflow-hidden">
            <div className="h-full w-1/3 bg-[hsl(var(--primary))] rounded-full animate-indeterminate" />
          </div>
          <p className="text-xs text-slate-500 mt-3">AI-generated just for you, this can take up to a minute.</p>
        </>
      )}
    </div>
  );
};
